/* Teads utils */
import CmpUtils from './cmp';
import DeviceConfig from '@devices/config';
import Event from '@shared/classes/event';
import { setPlayAd } from '@shared/store/slices/ads.slice';
import { store } from '@shared/store/store';

const DEBUG = false;

export enum Placement {
  IN_PLAY = 'inPlay',
  IN_PAUSE = 'inPause',
}

const TeadsUtils = {
  initializeTeads: ({
    asset,
    placementType,
    placementId,
    containerId,
    videoId,
  }: {
    asset?: Event;
    placementType: Placement;
    placementId: number;
    containerId: string;
    videoId?: string;
  }) => {
    DEBUG && console.info('[Teads] Initializing');

    const { media } = store.getState();
    const { info, seller } = DeviceConfig;
    const { userAgent } = window.navigator;
    const gdprConsent = CmpUtils.getGDPR();

    DEBUG &&
      console.info('[Teads] Container:', document.getElementById(containerId));
    DEBUG &&
      videoId &&
      console.info('[Teads] Video:', document.getElementById(videoId));

    // App context
    const appContext = {
      dom: {
        refElement: document.getElementById(containerId),
        ...(videoId ? { videoElement: document.getElementById(videoId) } : {}),
      },
      application: {
        appId: seller.bundleId,
        appStoreUrl: seller.storeUrl,
      },
      contentMetaData: {
        livestream: media.live,
        ...(asset
          ? { genre: asset.genreTitle, channel: asset?.channel?.name }
          : {}),
      },
      device: {
        userAgent,
        deviceType: 3,
        deviceId: info.uuid,
      },
      user: gdprConsent
        ? {
            gdpr: 1,
            gdprConsent,
          }
        : {},
    };

    // Placement context
    const placementContext = {
      playerHeight: 1080,
      playerWidth: 1920,
      placementId: placementId, // DEMO ID - OUR ID: 25889
      minDuration: 0,
      maxDuration: 60,
    };

    // Create the SDK instance and initialize an InPlay placement
    const sdkInstance = window.teads?.SDK?.create(appContext);
    if (!sdkInstance) return {};
    const placementInstance =
      placementType === Placement.IN_PLAY
        ? sdkInstance.initInPlay(placementContext)
        : sdkInstance.initInPause(placementContext);

    // Placement events
    placementInstance?.addEventListener('adLoaded', function () {
      DEBUG && console.info('[Teads] InPlay: Ad loaded');
      placementInstance.playAd();
    });
    placementInstance?.addEventListener('adCompleted', function () {
      DEBUG && console.info('[Teads] InPlay: Ad playback completed');
      placementInstance.stopAd();
      if (placementType === Placement.IN_PLAY) {
        store.dispatch(setPlayAd({ active: false }));
      }
    });
    placementInstance?.addEventListener(
      'adFailedToLoad',
      function (event: any) {
        DEBUG &&
          console.error(
            '[Teads] InPlay: Ad failed to load:',
            event?.detail?.error
          );
      }
    );
    placementInstance?.addEventListener('adError', function (event: any) {
      DEBUG && console.error('[Teads] InPlay: Ad error:', event?.detail?.error);
    });

    // Return the SDK instance and the placement instance
    return { sdkInstance, placementInstance };
  },
};

export default TeadsUtils;
